module.exports = __webpack_public_path__ + "img/login_dksteel.e16571b8.svg";